import { OrderModule } from 'ngx-order-pipe';
import { HeaderModule } from './../components/header/header.component.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({

  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    OrderModule,
    TranslateModule,
    HttpClientModule
  ],
  exports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    OrderModule,
    TranslateModule,
    HttpClientModule,
  ]
})
export class SharedModule { }
